import './App.css';


import React from 'react';

import FsBuild from './FsBuild'
import FsPreView from './FsPreView'
import FsMainFrame from './FsMainFrame'

// import FsPub from './FsPub'

import {message, Spin} from '@jd/find-react';

 
 
import KeeVue from './components/base/KeeVue.js'

import {Message, MessageBox} from 'element-react';

import $ from 'jquery';

// let pid = 'cityManager/tableList';
// let appId = '2021031708594945141281972480-CSY';
// let tid = "2021022615165624282776624050-city26";
// let keyName = "city26";

// let staticUrl = "http://dev-jinrong.xjoycity.com/ggyw-static-web";

// let userRootUri = "";
// let webUrl="http://ex-demo.xjoycity.com/demo26";

// let initSelectPageCode = "tableList";

class App extends KeeVue {
	constructor(props) {
		super(props);
		this.state = {
			isShowDesign: true,
			vueJsArray:[],
			vueloadedCount:0,
		}

		this.myRef = React.createRef();

	}
	componentWillMount() {
		
		console.log("......");
		
		//alert("window.location.hash:"+window.location.hash);
		if (window.location.hash === '#preview') {
			this.state.isShowDesign = false;
		} else {
			this.state.isShowDesign = true;
		}
		
		if(window._sign=="#escape(_sign)")
		{
			window._sign = "";
			window._rsakey="";
			window._publicKey="";
			  
		}

		//alert("jiazaizai");
		window.showPubMessage = function(msg) {
			if (msg == null) {
				return;
			}
			if (typeof msg == "string") {
				message.success(msg);
				return;
			}
			if (msg.success == false) {
				msg.error(msg.message);
			} else {
				if (msg.message) {

					message.success(msg.message);
				} else {
					message.success(msg);
				}
			}

		}

		window.showErrorPubMessage = function(msg) {
			if (msg == null) {
				return;
			}
			if (typeof msg == "string") {
				message.error(msg);
				return;
			}
			if (msg.success == false) {
				msg.error(msg.message);
			} else {
				if (msg.message) {

					message.error(msg.message);
				} else {
					message.error(msg);
				}
			}

		}

		// 判断页面应该用何种方式显示
		if (this.getUrlParameter("from") == "short") {
			// 代表从移动端过来的请求，有可能是APP或者是小程序

			// var url = window.location.protocol+"//"+window.location.host+"/clientConfig/getMap";
			// if(process.env.NODE_ENV=='development')  {
			// 	window.rootUri="http://ec.jdcloud.com/";
			// 	url = "http://ec.jdcloud.com/clientConfig/getMap";
			// } else {
			// 	window.rootUri="";
			// }

			// // 加载京智办的sdk
			// this.doRequest(url,(ret)=>{ });

		}

	}

	scanByJingBan=(url,ret)=>{
		//"https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/gwork/jssdk/JZB-JSSDK-1.0.1.js"
		this.loadJs(ret.pcSdkUrl, () => {

			//if (this.getUrlParameter("from") == "short" && !window.isMp)

			{
				//alert("从移动端，不是小程序")
				// 从移动端，不是小程序
				const param = {
					appKey: ret.appKey,
					callback: (result) => {
						//alert(JSON.stringify(result));
						

						if (result && result.code) {
							let code = result.code;
							let content = "获取到code：" + code;

							window.jzbCode = code;

							this.doRequest('/sysClientLog/save', function(data) {}, {
								content: content,
								platform: 'web',
								userId: window.currentUserId,
								type: 'info'
							});
							this.state.loadUrlinfo = "/login/loginByJingzhiban";
							this.refresh();
							this.doRequest(ret.passportUrl + "/login/loginByJingzhiban", (retjingzhiban) => {

								//alert(JSON.stringify(retjingzhiban));
								if(retjingzhiban.success) {
									// 注册并登陆成功
									this.state.loadUrlinfo= "retLogin.success";
									this.startLoadApp(ret);
								} else {
									alert("mainInfo登录失败！")
									this.state.loadUrlinfo= "retLogin.false";
								}
								
								this.refresh();

							}, {
								code: code,
								keyName: ret.keyName
							})

						} else {
							this.state.loadUrlinfo = "获取code失败！";
							this.refresh();
						}
					}
				};
				
				if(process.env.NODE_ENV=='development')  {
					
					window.jzbCode="ef9df25e9ed744ce96faa93a00d3dcab";
					 param.callback({
						 code:"ef9df25e9ed744ce96faa93a00d3dcab"
					 })
				} else {
					 window.jme.login.getAuthorizationCode(param);
				}
				
				
				

				setTimeout(() => {
					if (!window.jzbCode) {
						this.state.loadUrlinfo = "";
						this.state.loadUrlinfo2 = ret.errorInfo1;
						this.refresh();
					}

				}, 10000)


				return;
			}

		})

	}

	init=(url,ret)=>{
		this.state.loadUrlinfo="/clientConfig/getMap";
		this.state.loadUrlinfo="/clientConfig/getMap-ok";
		this.refresh();
		window.tid = ret.tid;
		window.keyName = ret.keyName;
		this.state.clientConfig = ret;
		
		let protocolStr = document.location.protocol;
		if(protocolStr == "https:")
		{ 
		   window.rootUri = window.rootUri.replace("http://","https://");
		}
		else
		{
			window.rootUri = window.rootUri.replace("https://","http://");
		}

		this.vueJsArray=[];
		// 加载Vue的js资源文件
		this.vueJsArray.push(window.rootUri+"/mainFrame/config?_t=4.20210825102000");
		this.state.loadUrlinfo="/mainFrame/getMainInfo";
		this.refresh();
		
		
		
		// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面
		this.doRequest("/mainFrame/getMainInfo",(mainInfo)=>{

			this.state.loadUrlinfo="/mainFrame/getMainInfo-ok"+mainInfo.success;
			this.refresh();
			let fromShort=this.getUrlParameter("from");
			{
				//如果是在京智办里面，则直接获取code进行登录操作，如果登录失败，则跳转到登录页面
				this.state.loadUrlinfo="/mainFrame/getMainInfo-ok2"+mainInfo.success;
				this.refresh();
				this.state.loadUrlinfo="非京办APP";
				this.refresh();
				if(this.getUrlParameter("appName").indexOf("REPORT_")!=-1||this.getUrlParameter("appCode").indexOf("REPORT_")!=-1) {
					// 不用登陆！或则严格，不显示
					// 需要注册成为游客；
					let youkename = localStorage.getItem("youkename");
					if(!youkename) {
						youkename = this.getRandString();
						localStorage.setItem("youkename",youkename);
					}
					this.state.loadUrlinfo= "/login/registYouke";
					this.refresh();
					this.doRequest(ret.passportUrl+"/login/registYouke?name="+youkename+"&keyName="+ret.keyName,(retLogin)=>{
						this.state.loadUrlinfo= "retLogin";
						if(retLogin.success) {
							// 注册并登陆成功
							this.state.loadUrlinfo= "retLogin.success";
							this.startLoadApp(ret);
						} else {
							this.state.loadUrlinfo= "retLogin.false";
						}

						this.refresh();
					})
					return ;

				}
			}
			this.refresh();
			this.beginRefresh();
		})
	}


	startLoadApp=(ret)=>{
		this.state.loadUrlinfo= "/getMainInfo";
		this.refresh();
		
		window.tid = ret.tid;
		window.keyName = ret.keyName;
		this.state.clientConfig = ret;
		
		this.vueJsArray=[];
		// 加载Vue的js资源文件
		this.vueJsArray.push(window.rootUri+"/mainFrame/config?_t=4.20210825102000");
		
	 
		
		
		
		// 然后获取用户信息，如果获取成功显示，如果获取失败，跳转到登录页面
		this.doRequest("/mainFrame/getMainInfo?_t=2",(mainInfo)=>{
			this.state.loadUrlinfo= "/getMainInfo-ret"+mainInfo.success;
			this.refresh();

			//alert(JSON.stringify(mainInfo));
			if(mainInfo.success) {
				// window._sign = mainInfo.retData._sign;
				// window._publicKey = mainInfo.retData.publicKey;
				// window._rsakey = mainInfo.retData.rsakey;
				// 获取成功
				this.state.mainInfo = mainInfo.retData;
				window.document.title = mainInfo.retData.systemTitle;
				console.log("window.document.title000:"+ mainInfo.retData.systemTitle);
			
			   if(this.state.mainInfo.sys.icon)
			   {
			   	this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.icon);
			   }
			   else
			   {
			   	this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
			   }
			    
				
				//this.selfSetIcon(this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo);
				//alert(JSON.stringify(this.state.mainInfo));
			} else {
				//如果是在京智办里面，则直接获取code进行登录操作，如果登录失败，则跳转到登录页面
				{
					var fromPlatform = this.state.clientConfig.fromPlatform;

					if(!fromPlatform) {
						fromPlatform = "";
					}
					 
					var loginUrl = ret.passportUrl+"/login?fromPlatform="+fromPlatform+"&tid="+ret.tid+"&keyName="+ret.keyName;
					loginUrl+="&returnUrl="+window.location.href;
					window.location.href=loginUrl.replace("http:",document.location.protocol);
					return ;
				}
			}
			this.state.loadUrlinfo= "kaishiload";
			this.refresh();

			this.vueJsArray.map((item,index)=>{
				this.state.loadUrlinfo= ""+item;
				this.refresh();
				this.loadJs(item,()=>{
					this.state.vueloadedCount++;
					this.refresh();

				});
			})
			this.refresh();
		})
	}
	 


	// 兼容Vue的方法
	$confirm(t1, t2, obj) {
		MessageBox.confirm(t1, t2, obj).then(() => {
			obj.callback("confirm", this);

		}).catch(() => {
			Message({
				type: 'info',
				message: '已取消删除'
			});
		});
	}
	render() {
		if (!this.hash) {
			this.hash = window.location.hash
		}
		let hash = this.hash;

		let sp = this.getUrlParameter("sp");
 
		/*
		if (this.getUrlParameter("from") == "short") {
			if(this.state.vueloadedCount==1) {
				window.isPub = true;
				return( <div className={`feas-page-container-pub `}><FsPub > </FsPub></div> )
			}
			return (<div style={{width:'100%',height:'100%',textAlign:'center',paddingTop:'300px'}}>
					{this.state.loadUrlinfo2?<span>{this.state.loadUrlinfo2}</span>:<Spin tip={""}>
					</Spin>}
				</div>
			)
		}

		if (sp.indexOf("PUB_") != -1) {
			window.isPub = true; 
			return <FsPub > </FsPub>
		}
		*/
		
		 
		// window.appCode 是网站的app模式，单个应用渲染
		if (this.getUrlParameter("from") == "short"|| hash.indexOf('#preview')==0||window.appCode||this.getUrlParameter("isPreview") == "true"||this.getUrlParameter("isPreview") == "1") {
			
			
			// 如果是网站，高度不能100%
			
			if(this.getUrlParameter("clientType")=="SITE"||window.appCode)
			{
				// 给增加一个预览模式的样式
				$("#feasApp").addClass("preview_mode");
				
				$("#feasApp").css("position","relative");
			}
			
			
			return <FsPreView > </FsPreView>
		}
		if (hash.indexOf('#dev')==0) {
			return <FsBuild > </FsBuild>
		}
		return <FsMainFrame > </FsMainFrame>
	}

}

export default App;
